import TypeformView from '../typeform/view/TypeformView';

export default function PrescriptionTypeformView({ dgUserProgramNo, formId }) {
  return <TypeformView formId={formId ? formId : 'pWBjfIJa'} dgUserProgramNo={dgUserProgramNo} isV4={true} />;
}
